export default "__VITE_ASSET__x5AYq5Ns__"